/*
  legacy-slideshow.js.liquid
  Consolidated/standalone slideshow logic extracted from sections.js.liquid
  Depends on: jQuery, Flickity, and global theme vars usePageDots, arrowSize

  This file provides a global `slideshow` object with `init` and `unload` methods.
  If a `slideshow` already exists, it will not be overwritten; the object in this
  file will also be exposed as `legacySlideshow` for direct use if needed.
*/

;(function(window, document, $){
  'use strict';

  // Build the slideshow object from the theme's original implementation
  var legacySlideshow = {
    init: function(){
      // Ensure Flickity is available before initializing
      if (!$ || !$.fn || typeof $.fn.flickity !== 'function') {
        return; // Required dependency not ready
      }

      $('.js-homepage-slideshow').each(function (){
        var $homepageSlider = $(this);
        var settings = {
          slideshowSpeed: ($homepageSlider.data('slideshow-speed') || 0) * 1000,
          slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation'),
          adaptiveHeight: $homepageSlider.data('adaptive-height')
        };

        // Initiate Flickity once per instance
        if (!$homepageSlider.hasClass('flickity-enabled')){
          var arrowShow = $homepageSlider.find('.gallery-cell').length !== 1;
          $homepageSlider.flickity({
            adaptiveHeight: settings.adaptiveHeight,
            wrapAround: true,
            cellAlign: 'left',
            imagesLoaded: true,
            prevNextButtons: arrowShow,
            draggable: arrowShow,
            pageDots: (typeof window.usePageDots !== 'undefined') ? window.usePageDots : true,
            autoPlay: settings.slideshowSpeed,
            arrowShape: (typeof window.arrowSize !== 'undefined') ? window.arrowSize : undefined
          });

          if (settings.slideshowTextAnimation){
            var flkty = $homepageSlider.data('flickity');
            setTimeout(function() {
              $homepageSlider
                .find('.gallery-cell:nth-child(1) .caption-content')
                .addClass('animated ' + settings.slideshowTextAnimation);
            }, 400);

            $homepageSlider.on('select.flickity', function() {
              if ($homepageSlider.is(':visible') && flkty) {
                var currentSlide = flkty.selectedIndex + 1;
                setTimeout(function() {
                  $homepageSlider.find('.caption-content')
                    .removeClass('animated ' + settings.slideshowTextAnimation);
                  $homepageSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content')
                    .addClass('animated ' + settings.slideshowTextAnimation);
                }, 400);
              }
            });
          }
        }

        // Mark single vs. multi image for styling hooks
        if ($homepageSlider.find('.gallery-cell').length > 1) {
          $homepageSlider.addClass('multi-image');
        } else {
          $homepageSlider.addClass('single-image');
        }

        // Make action buttons same width per slide
        $homepageSlider.find('.gallery-cell').each(function(){
          var buttonWidth = 0;
          $(this).find('.action_button').each(function(){
            var $button = $(this);
            if ($button.width() > buttonWidth){
              buttonWidth = $button.width();
            }
          });
          $(this).find('.action_button').width(buttonWidth);
        });
      });
    },

    unload: function($target){
      if (!$ || !$target) { return; }
      var $slider = $target.find('.js-homepage-slideshow');
      if ($slider.length && $slider.hasClass('flickity-enabled')){
        try { $slider.flickity('destroy'); } catch (e) { /* noop */ }
      }
    }
  };

  // Expose as legacySlideshow; conditionally set global slideshow if absent
  window.legacySlideshow = legacySlideshow;
  if (typeof window.slideshow === 'undefined') {
    window.slideshow = legacySlideshow;
  }

})(window, document, window.jQuery);
